import SpecialClassForm from "@/components/teacher/special-class/SpecialClassForm";
import { useTranslation } from "react-i18next";

export default function SpecialClassFormPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-form-blue text-white py-6 shadow-md">
        <div className="container max-w-4xl mx-auto px-4">
          <h1 className="text-2xl md:text-3xl font-bold">{t('specialClass.pageTitle')}</h1>
          <p className="mt-2 text-blue-100">{t('specialClass.pageSubtitle')}</p>
        </div>
      </header>

      <main className="container max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
          <SpecialClassForm />
        </div>
      </main>
    </div>
  );
}